import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export default {
    install: (Vue, pluginConfig) => {
        Vue.prototype.$CookieConsent = CookieConsent;
        CookieConsent.run(pluginConfig);
    }
}

let metaPixelInitialized = false;
let salesmanagoInitialized = false;

function initializeMetaPixel() {
    if (metaPixelInitialized) {
        return;
    }

    // *** INIZIO CODICE META PIXEL ***
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '402215097010614'); // Il tuo ID Pixel
    fbq('track', 'PageView');
    // *** FINE CODICE META PIXEL ***

    metaPixelInitialized = true;
}

// --- FUNZIONE PER L'INIZIALIZZAZIONE DI SALESMANAGO ---
function initializeSalesmanago() {
    if (salesmanagoInitialized) {
        return;
    }

    window._smid = "8828b555c4d7afdf";
    window._smapp = 1;
    (function(w, r, a, sm, s ) {
        w['SalesmanagoObject'] = r;
        w[r] = w[r] || function () {( w[r].q = w[r].q || [] ).push(arguments)};
        sm = document.createElement('script'); sm.type = 'text/javascript'; sm.async = true; sm.src = a;
        s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(sm, s);
    })(window, 'sm', ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.salesmanago.com/static/sm.js');

    salesmanagoInitialized = true;
}

document.addEventListener('DOMContentLoaded', () => {
    if (typeof CookieConsent !== 'undefined' && CookieConsent.getUserPreferences) {
        const userPreferences = CookieConsent.getUserPreferences();
        if (userPreferences && userPreferences.acceptedCategories && userPreferences.acceptedCategories.includes('marketing')) {
            initializeMetaPixel();
            initializeSalesmanago();
        }
    }
});


 